import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Services from '../components/Services';
import ContactForm from '../components/ContactForm';

export default function HomePage() {
  return (
    <main>
      <Helmet>
        <title>VHservice | Professionel vinduespudsning og ejendomsservice</title>
        <meta name="description" content="Få krystalklare ruder med VHservice. Vi tilbyder professionel vinduespudsning og ejendomsservice til private og erhverv." />
      </Helmet>
      <Hero />
      <Services />
      <section id="about" className="pt-12 pb-0 lg:py-24 bg-white overflow-hidden relative">
        {/* Watermark */}
        <div className="absolute -right-20 top-1/2 -translate-y-1/2 w-96 h-96 md:w-[600px] md:h-[600px] opacity-[0.04] pointer-events-none select-none z-0 -rotate-12">
          <img 
            src="https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/ac472147-87b0-4472-bb47-5f636b720560.png" 
            alt="" 
            className="w-full h-full object-contain grayscale"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-0 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative order-2 lg:order-1 w-full md:max-w-2xl md:mx-auto lg:max-w-none">
              <div className="absolute -left-12 -top-12 w-64 h-64 bg-blue-50 rounded-none mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
              <div className="relative rounded-none overflow-hidden shadow-2xl">
                <img 
                  src="https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/7a24ac79-616a-4dfb-8f50-54377eb87049.jpg" 
                  alt="Vores værktøj og kvalitet" 
                  className="w-full aspect-square object-cover"
                />
              </div>
            </div>
            <div className="order-1 lg:order-2 px-4 sm:px-6 lg:px-0">
              <h2 className="text-3xl lg:text-5xl font-bold mb-8 text-gray-900">Om VHservice</h2>
              <div className="space-y-6 text-xl text-gray-600 leading-relaxed">
                <p>
                  VHservice startede med en simpel vision: At gøre vinduespudsning til en nem og gennemsigtig oplevelse for alle. Vi ved, at dine ruder er dit vindue mod verden, og derfor går vi aldrig på kompromis med kvaliteten.
                </p>
                <p>
                  Vi benytter os af de nyeste teknikker og det bedste udstyr på markedet, der sikrer et stribefrit resultat uden brug af skrappe kemikalier.
                </p>
              </div>
              <div className="mt-10">
                <Link 
                  to="/om-os"
                  className="inline-flex items-center text-black font-bold text-lg group"
                >
                  Læs mere om vores historie og værdier
                  <svg 
                    className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
    </main>
  );
}
